// parseEnvironmentalData.js

export function parseEnvironmentalData(json, setDataBuffer) {
  const experimentStartTime = json.data[0]?.experimentStartTime;
  if (experimentStartTime === undefined) {
    console.warn("Missing experimentStartTime in environmental data");
    return;
  }

  const environmentalPoints = json.data
    .filter(entry => entry.environment && entry.environment.temp !== undefined)
    .map(entry => ({
      timestamp: entry.timestamp * 1000,
      relativeTime: entry.timestamp - experimentStartTime,
      temp: entry.environment.temp,
      oxygen: entry.environment.O2,
    }));

  setDataBuffer(prev => {
    const next = [...prev, ...environmentalPoints].filter(
      (point, i, arr) => arr.findIndex(p => p.timestamp === point.timestamp) === i
    );
    //return next.length > BUFFER_SIZE ? next.slice(-BUFFER_SIZE) : next;

    // next accumulates and preserves all environmental data, prevents duplicate by timestamps
    return next;
  });
}

